import { config } from '@tshared/config/config'
import { publicUserReq } from '@tshared/oapi/req/public-user-req'

import type { User } from '../models'

const DEFAULT_CLIENT_ID = 'DEFAULT'

export type SignInCredentials = {
  username: string
  password: string
}

export async function loginWithPassword(credentials: SignInCredentials): Promise<User | null> {
  switch (config.getAccountType()) {
    case 'warden-app': {
      const res = await publicUserReq.POST('/api/user/warden/auth/login', {
        body: {
          email: credentials.username,
          password: credentials.password,
        },
      })
      return res.data?.data ?? null
    }
    case 'loneworker-app': {
      const res = await publicUserReq.POST('/api/user/mobile/auth/login', {
        body: {
          email: credentials.username,
          password: credentials.password,
        },
      })
      return res.data?.data ?? null
    }
    case 'web':
    default: {
      const res = await publicUserReq.POST('/api/user/auth/login', {
        body: credentials,
      })
      return res.data?.data ?? null
    }
  }
}

export async function refreshAccessToken(refreshToken: string): Promise<User> {
  switch (config.getAccountType()) {
    case 'warden-app': {
      const res = await publicUserReq.POST('/api/user/warden/auth/refresh-token', {
        body: {
          refreshToken,
          clientId: DEFAULT_CLIENT_ID,
        },
      })
      return requireAccessToken(res.data?.data, res.data?.message)
    }
    case 'loneworker-app': {
      const res = await publicUserReq.POST('/api/user/mobile/auth/refresh', {
        body: { refreshToken },
      })
      return requireAccessToken(res.data?.data, res.data?.message)
    }
    case 'web':
    default: {
      const res = await publicUserReq.POST('/api/user/auth/refresh-token', {
        body: {
          refreshToken,
          clientId: DEFAULT_CLIENT_ID,
        },
      })
      return requireAccessToken(res.data?.data, res.data?.message)
    }
  }
}

function requireAccessToken(user: User | undefined, message?: string): User {
  if (!user?.accessToken) {
    throw new Error(message ?? 'Failed to refresh user')
  }
  return user
}
